"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var api_config_1 = require("./api-config");
var converter_mapping_1 = require("./converter-mapping");
var ApiConfigFactory = /** @class */ (function () {
    function ApiConfigFactory() {
    }
    ApiConfigFactory.getDefaultInstance = function () {
        if (!ApiConfigFactory._) {
            ApiConfigFactory._ = new api_config_1.ApiConfig(exports.defaultRoutes, converter_mapping_1.converterMapping, exports.defaultAliases);
        }
        return ApiConfigFactory._;
    };
    return ApiConfigFactory;
}());
exports.ApiConfigFactory = ApiConfigFactory;
exports.defaultAliases = {
    "/device/current-time": "/3//13",
    "/interface/config-format-version": "/1024//8",
    "/target/transparent/send-receive": "/1027//34",
    "/bundle/{bundleId}/acl": "/1028/{bundleId}/0",
    "/interface/available-host-protocols": "/1024//21",
    "/target/com-stats": "/1027//11",
    "/interface/host-inactivity-period": "/1024//34",
    "/variable/{variableId}/name": "/1029/{variableId}/8",
    "/interface/cloud/connection-mode": "/1024//26",
    "/lora/ids": "/1024//90",
    "/adp/control-in": "/1027//41",
    "/device/last-error-code": "/3//11",
    "/data-log/max-packet-count": "/1024//23",
    "/variable/{variableId}/unit": "/1029/{variableId}/9",
    "/target/core-type": "/1027//2",
    "/device/power-source-voltage": "/3//7",
    "/interface/cloud/password": "/1024//29",
    "/variable/read-profile": "/1029//4",
    "/scram/login-proof": "/1024//41",
    "/scram/initialize": "/1024//47",
    "/target/firmware-version": "/1027//6",
    "/bundle/{bundleId}/create": "/1028/{bundleId}/65535",
    "/firmware/package": "/5//0",
    "/scram/hash-iteration": "/1024//42",
    "/interface/power-optimisation-level": "/1024//14",
    "/interface/current-host-protocol": "/1024//3",
    "/target/transparent/send": "/1027//34",
    "/device/serial-number": "/3//2",
    "/single-packet/write": "/1024//80",
    "/lora/config": "/1024//91",
    "/interface/client-certificate": "/1024//37",
    "/interface/special-feature/{featureId}": "/1024//{featureId}",
    "/interface/login-with-hash": "/1024//0",
    "/cloud/upload-period": "/1024//33",
    "/interface/app-path": "/1024//11",
    "/interface/functions": "/1024//20",
    "/interface/application-parameters": "/1024//36",
    "/data-log/options": "/1031//2",
    "/variable/{variableId}/current-access": "/1029/{variableId}/3",
    "/interface/keep-alive": "/1024//4",
    "/adp/control-out": "/1027//42",
    "/bundle/{bundleId}/values": "/1028/{bundleId}/1",
    "/device/firmware-version": "/3//3",
    "/variable/{variableId}/bundle/id": "/1029/{variableId}/6",
    "/interface/network-mode": "/1024//15",
    "/target/reset": "/1027//5",
    "/interface/universal-link": "/1024//19",
    "/target/reset-keep": "/1027//30",
    "/variable/{variableId}/address": "/1029/{variableId}/0",
    "/target/disconnect": "/1027//4",
    "/bundle/{bundleId}/name": "/1028/{bundleId}/4",
    "/interface/config-format-firmware-version": "/1024//18",
    "/target/modbus/read": "/1027//38",
    "/secure-element/send": "/1024//71",
    "/target/read-address": "/1027//33",
    "/variable/{variableId}/set-value": "/1029/{variableId}/5",
    "/target/modbus/write": "/1027//37",
    "/interface/nfc_connection_priority": "/1024//24",
    "/secure-element/config": "/1024//70",
    "/interface/mqtt/relay/password": "/1024//54",
    "/interface/network/infra-ip-mask": "/1024//32",
    "/interface/cloud-gateway-url": "/1024//12",
    "/interface/cloud/client-id": "/1024//27",
    "/interface/login-uid": "/1024//5",
    "/variable/{variableId}/type": "/1029/{variableId}/1",
    "/single-packet/bspe": "/1024//83",
    "/data-log/dequeue-packet": "/1031//11",
    "/interface/mqtt/relay/client-id": "/1024//52",
    "/target/protocol": "/1027//1",
    "/target/adp/action": "/1027//39",
    "/interface/public-password": "/1024//60",
    "/firmware/update": "/5//2",
    "/target/min-voltage": "/1027//8",
    "/single-packet/part": "/1024//82",
    "/interface/authorized-host-protocol": "/1024//17",
    "/target/register-access": "/1027//32",
    "/interface/wep-key": "/1024//16",
    "/data-log/packet-count": "/1031//10",
    "/target/protocol-configuration": "/1027//21",
    "/device/model-name": "/3//1",
    "/variable/{variableId}/value": "/1029/{variableId}/4",
    "/interface/wifi/hostname": "/1024//35",
    "/interface/lock": "/1024//6",
    "/device/memory-free": "/3//10",
    "/group/{groupId}/password-key": "/1025/{groupId}/2",
    "/interface/mqtt/relay/url": "/1024//50",
    "/target/sub-protocol": "/1027//40",
    "/bundle/{bundleId}/data-log-period": "/1028/{bundleId}/2",
    "/interface/rand": "/1024//49",
    "/interface/multi-request": "/1024//89",
    "/interface/network/infra-ip": "/1024//30",
    "/interface/mqtt/relay/login": "/1024//53",
    "/interface/ble/address": "/1024//22",
    "/scram/send-with-iv": "/1024//44",
    "/interface/wifi/ssid": "/1024//25",
    "/group/{groupId}/session-lifetime": "/1025/{groupId}/4",
    "/device/manufacturer": "/3//0",
    "/interface/current-group-id": "/1024//7",
    "/group/{groupId}/name": "/1025/{groupId}/0",
    "/device/available-power-source": "/3//6",
    "/interface/client-private-key": "/1024//38",
    "/target/uart/settings": "/1027//21",
    "/variable/{variableId}/bundle/values": "/1029/{variableId}/7",
    "/interface/cloud/service-name": "/1024//61",
    "/target/vcc": "/1027//7",
    "/target/debug-access": "/1027//31",
    "/data-log/crypto-key": "/1031//3",
    "/interface/config-version": "/1024//10",
    "/variable/{variableId}/create": "/1029/{variableId}/65535",
    "/group/{groupId}/password": "/1025/{groupId}/2",
    "/variable/{variableId}/number-of-elements": "/1029/{variableId}/2",
    "/single-packet-store/info": "/1024//81",
    "/scram/login": "/1024//40",
    "/interface/cloud/login": "/1024//28",
    "/target/page-size": "/1027//10",
    "/interface/mqtt/relay/port": "/1024//51",
    "/variable/{variableId}/format": "/1029/{variableId}/1",
    "/interface/network/gateway-ip": "/1024//31",
    "/data-log/flush": "/1031//4",
    "/interface/nfc-autolog-profile-id": "/1024//43",
    "/target/adp/status": "/1027//36",
    "/target/connect": "/1027//3",
    "/interface/login": "/1024//0",
    "/firmware/crc-check": "/5//6",
    "/scram/com-send-receive": "/1024//48",
    "/scram/initialization-vector": "/1024//45",
    "/interface/app-name": "/1024//9",
    "/device/factory-reset": "/3//5",
    "/target/max-voltage": "/1027//9",
    "/group/{groupId}/create": "/1025/{groupId}/65535",
    "/interface/mqtt/relay/net-key": "/1024//55",
    "/firmware/state": "/5//3",
    "/interface/nfc/pairing-mode": "/1024//13",
    "/interface/current-profile/id": "/1024//2",
    "/device/reboot": "/3//4",
    "/interface/mqtt-relay-certificate": "/1024//58",
    "/device/reset-last-error-code": "/3//12",
    "/data-log/stop": "/1031//1",
    "/target/received-count": "/1027//43",
    "/interface/current-host-protocol-max-frame-size": "/1024//88",
    "/interface/logout": "/1024//1",
    "/target/transparent/read-bytes": "/1027//35",
    "/target/available-protocols": "/1027//20",
    "/data-log/run": "/1031//0",
    "/group/{groupId}/alias": "/1025/{groupId}/5",
};
exports.defaultRoutes = {};
